// extracted by mini-css-extract-plugin
module.exports = {"avatar":"K4PlMeQG3siOmlAClIhbI","dashboard":"_3pYkIuRWf8t3FJ6OPD88NV"};